export default __webpack_public_path__ + "static/media/logo2.b26833da.svg";